var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPmBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3092_90804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5431 5.54684V0.890625H3.99953L0.738281 4.68685V18.7784H20.862V5.54684H13.5431ZM12.4308 17.6972H9.67513V14.6873H7.82961V17.6972H5.1119V1.97175H12.4308V17.6972ZM15.7552 16.8618H14.4912V14.589H15.7552V16.8618ZM15.7552 13.2499H14.4912V10.977H15.7552V13.2499ZM15.7552 9.63792H14.4912V7.3651H15.7552V9.63792ZM19.0417 16.8618H17.7777V14.589H19.0417V16.8618ZM19.0417 13.2499H17.7777V10.977H19.0417V13.2499ZM19.0417 9.63792H17.7777V7.3651H19.0417V9.63792Z",
    fill: "#FF5E6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3092_90804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1237,
    height: 17.8877,
    fill: "white",
    transform: "translate(0.738281 0.890625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmBuilding);
export default __webpack_public_path__ + "static/media/pm-building.c2c8b42933bb3f6445ff52f6d651a5fe.svg";
export { ForwardRef as ReactComponent };